import { useAuthPage } from "@features/auth/useAuthPage";

export function usePermission() {
  const { user } = useAuthPage();
  const isAdmin = user?.role.name == "admin";

  return isAdmin;
}